module.exports = __webpack_public_path__ + "static/eyeball-reporter-logo-b47f76d7402825180a56ab36cec4d547.svg";